/**
 * Mock de laboratorio — estudios de hoy y pruebas pendientes de mapeo.
 */

export const MOCK_LAB_STUDIES_TODAY = 94;

/** Pruebas que deben pasar por un bioanalista para clasificarlas */
export const MOCK_LAB_PENDING_MAPPING = 17;

export const MOCK_LAB_SPARKLINE = [8, 12, 9, 14, 11, 15, 10, 13, 16, 12, 14, 18];
